import React, { useState } from 'react';
import { TopUtilityBar } from './components/layout/TopUtilityBar';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { MobileMenu } from './components/layout/MobileMenu';
import { CartDrawer } from './components/shared/CartDrawer';
import { HomePage } from './pages/HomePage';
import { ProductListingPage } from './pages/ProductListingPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
export function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'shop' | 'product'>('home');
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const handleNavigate = (page: 'home' | 'shop' | 'product') => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen flex flex-col font-body text-gray-900 bg-white" data-id="element-0">
      <TopUtilityBar data-id="element-1" />
      <Header onNavigate={handleNavigate} onOpenCart={() => setIsCartOpen(true)} onOpenMobileMenu={() => setIsMobileMenuOpen(true)} data-id="element-2" />

      <div className="flex-grow" data-id="element-3">
        {currentPage === 'home' && <HomePage onNavigate={handleNavigate} data-id="element-4" />}
        {currentPage === 'shop' && <ProductListingPage onNavigate={handleNavigate} data-id="element-5" />}
        {currentPage === 'product' && <ProductDetailPage data-id="element-6" />}
      </div>

      <Footer data-id="element-7" />

      <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} data-id="element-8" />

      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} onNavigate={handleNavigate} data-id="element-9" />
    </div>;
}